import  { useEffect, useState } from 'react';
import { useHistory,useParams } from 'react-router-dom';
import _ from 'lodash';
import { HeaderWrapper } from '../../../../../NCommon/HeaderWrapper';
import { NavigationWrapper } from '../../../../../NCommon/NavigationWrapper';
import {PaginationTable} from '../../../../../NCommon/Tables/PaginationTable';
import { Card } from '../../../../../NCommon/Ui/CardLayout';
import { List } from '../../../../../NCommon/Ui/List';
import { PageWrapper } from '../../../../../NCommon/PageWrapper';
import { useTableCount } from '../../../../../Hooks/TableCount';
import { get } from '../../../../../../Model/Network/Config/Axios';
import { PageLoader } from '../../../../../Common/PageLoader';
import { useProject } from '../../../../../Hooks/ProjectDetails';


const Index = () => {

    const [employees,setEmployees] = useState({
        page:0,
        total:0,
        items:[]
    });
    const [loading,setLoading] = useState(true);
    const [filters,setFilters] = useState([]);
    const HISTORY = useHistory();
    let {id}  = useParams();
    let count = useTableCount();
    let project = useProject();

    useEffect(()=>{
        INIT({page:0})
    },[count])

    let INIT = (data) => {
        if(!data) {
            data = {page:0}
        }

        if(data.filter){
            data = {
                ...data,
                ...data.filter
            }
            delete data.filter;
        }
        data.size = `${count}`;
        data.offset = data.page ? (data.page*count).toString():"0"
        get(`employees/all`, (e, r) => {
            if (r) {
                setEmployees({
                    items:r.employees,
                    page:data.page,
                    total:r.total?r.total:employees.total
                });
                setLoading(false);
            }
        },data)
    }
    
    let mapCardLayout = (item,index) => {
        return(
            <Card onClick={()=>{HISTORY.push(`/app/project/images/${id}/employee/${item.id}/details?name=${item.name}`)}} icon={true} key={index} title={item.name} desc={item.email}>
                <div style={{marginLeft:55}}>
                    <p className="tiny-text">{item.employeeCode}</p>
                </div>
            </Card>
        )
    }

    let next = (page) => {
        INIT({page})
    }

    let mapListLayout = (item,index) => {
        return(
            <List onClick={()=>{HISTORY.push(`/app/project/images/${id}/employee/${item.id}/details?name=${item.name}`)}}  key={index}>
                <div className="flex-1">
                    <p className="table-title">{item.name}</p>
                    <p className="table-bottom">{item.email}</p>
                </div>
                <div className="flex-1">
                    <p className="table-text">{item.employeeCode}</p>
                </div>
            </List>
        )
    }



     return (
            <>
                {
                    loading ?
                        <PageLoader />
                        :
                        <>
                            <HeaderWrapper filters={[...filters]} dynamicFilter={true} onFilterChange={items=>{
                                let filter = {};
                                items.forEach(item=>{
                                    filter[item.type] = item.value;
                                })
                                setFilters(items)
                                INIT({page:0,filter})
                            }} types={["Employee Name"]}   />
                            <PageWrapper id="pagination-table-header" scroll={true}>
                                <NavigationWrapper items={[{name:"All Project",path:`/app/project`},{name:`${project.name}`,path:`/app/project/mapping/${id}`},{name:`All Employees (${employees.total})`}]} />
                                <PaginationTable
                                    DATA={employees.items}
                                    next={(page)=>{
                                        next(page)
                                    }}
                                    mapListLayout={mapListLayout}
                                    mapCardLayout={mapCardLayout}
                                    total={employees.total}
                                    page={employees.page}
                                    headers={[
                                        {
                                            name:'Details',
                                            flex:1
                                        },
                                        {
                                            name:'Employee Code',
                                            flex:1
                                        }
                                    ]}
                                />
                            </PageWrapper>
                        </>
                }
            </>
        )
}

export default Index;